/**
 * Capability (sezioni) che un ServizioLogico può esporre nel menu data-driven.
 * Le voci comuni (home/bandi/pratiche/pagamenti) hanno ordine FISSO; le specifiche
 * (figli/menu/calendario) finiscono nel gruppo etichettato col nome del servizio.
 *
 * Vedi design.md §5 (menu a tre fasce) e shared/constants/servizio-logico.const.ts.
 */
export enum ServizioCapability {
  BANDI = 'bandi',
  PRATICHE = 'pratiche',
  VOUCHER = 'voucher',
  PAGAMENTI = 'pagamenti',
  FIGLI = 'figli',
  MENU = 'menu',
  CALENDARIO = 'calendario',
  TARIFFE = 'tariffe',
}
